import { ModuleManager } from "@module-system";
import { createI18n } from "vue-i18n";
import axios from "axios";

export const availableLocales = [
    { code: "tr", flag: "fi fi-tr", name: "Türkçe", fallBackLanguageCode: "en" },
    { code: "en", flag: "fi fi-gb", name: "English", fallBackLanguageCode: "tr" },
];

export const baseLocaleConfig = {
    locale: window.localStorage.getItem("locale") || window.CONFIG.LOCALE || "tr",
    fallbackLocale: window.CONFIG.FALLBACK_LOCALE || "tr",
    messages: {},
};

function getLocaleConfig() {
    const moduleLocales = ModuleManager.locales || [];
    let mergedLocales = {
        ...baseLocaleConfig.messages,
    };

    for (const mod of moduleLocales) {
        for (const key in mod) {
            if (Object.hasOwnProperty.call(mod, key)) {
                // modulden gelen tek locale (tr,en vb içeriği)
                const moduleLocale = mod[key];

                mergedLocales[key] = {
                    ...mergedLocales[key],
                    ...moduleLocale,
                };
            }
        }
    }

    return {
        ...baseLocaleConfig,
        messages: mergedLocales,
    };
}

export function ecvI18N(dynamicTranlationAppId) {
    let i18n = createI18n(getLocaleConfig());

    ModuleManager.i18nNotifiers.push((locale, source) => {
        const keyCount = Object.keys(locale).length;

        console.log(
            `i18n notifier called from "${source ?? 'unknown'}". has ${keyCount} languages`
        );
        for (const langCode in locale) {
            if (Object.hasOwnProperty.call(locale, langCode)) {
                const lang = locale[langCode];
                console.log(
                    `i18n merging ${langCode} locale from "${source ?? 'unknown'}". has ${Object.keys(lang).length} keys`
                );
                i18n.global.mergeLocaleMessage(langCode, lang);
            }
        }
    });

    // dynamic locales and languages from db
    // when app starts, fetch dynamic locales and merge them
    // additionally, add dynamic languages to availableLocales

    (async () => {
        try {
            // web.app = 0, web.admin = 1
            var dynamic_locales_resp = await axios.get("/api/translations/" + dynamicTranlationAppId);
            var data = dynamic_locales_resp.data;

            var dynamic_locales = data.translations;

            // modify available locales, clear first and add data.languages

            let count = availableLocales.length;

            for (const lang of data.languages) {
                availableLocales.push(lang);
            }

            // remove default locales
            availableLocales.splice(0, count);

            for (const langCode in dynamic_locales) {
                if (Object.hasOwnProperty.call(dynamic_locales, langCode)) {
                    const lang = dynamic_locales[langCode];
                    console.log(`merging ${langCode} locale. has ${Object.keys(lang).length} keys`);
                    i18n.global.mergeLocaleMessage(langCode, lang);
                }
            }

            var currentLanguage = availableLocales.find((x) => x.code == i18n.global.locale);

            if (!currentLanguage) {
                currentLanguage = availableLocales.find((x) => x.code == i18n.global.fallbackLocale);
            }

            if (!currentLanguage) {
                currentLanguage = availableLocales[0];
            }

            console.log("i18n currentLanguage", currentLanguage);
            i18n.global.locale = currentLanguage.code;
            i18n.global.fallbackLocale = currentLanguage.fallBackLanguageCode || window.CONFIG.FALLBACK_LOCALE || "tr";

            console.log("18n global locale", i18n.global.locale);
            console.log("18n global fallbackLocale", i18n.global.fallbackLocale);
        } catch (error) {
            console.error(error);
            return;
        }
    })();

    return i18n;
}
